import styled from "styled-components";
import {JackpotToastSuggestedGamesTitleDefaultBox} from "./jackpot-toast-suggested-games-title.default.box";

export const JackpotToastSuggestedGamesTitleMrGreenBox = styled(JackpotToastSuggestedGamesTitleDefaultBox)`
    color: ${props => props.theme.colors.textContrast};
`;